import React from 'react';
import { ResponsivePie } from '@nivo/pie';

const DonutChart = (props) => {
  const mealAggObject = props.data;
  const data = [];

  for (const item in mealAggObject) {
    data.push({
      id: `${item}`,
      value: mealAggObject[item],
      // color: '#ff0000'
    });
  }

  return (
    <div style={{ height: 280 }}>
      <ResponsivePie
        data={data}
        margin={{ top: 45, right: 70, bottom: 45, left: 70 }}
        innerRadius={0.6}
        padAngle={5}
        cornerRadius={2}
        sortByValue={true}
        colors={{ scheme: 'paired' }}
        // colors={['#ff0000', '#0000ff']}
        // colors={item => item.color}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
        radialLabelsSkipAngle={10}
        radialLabelsTextXOffset={3}
        radialLabelsTextColor="#333333"
        radialLabelsLinkOffset={0}
        radialLabelsLinkDiagonalLength={20}
        radialLabelsLinkHorizontalLength={10}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        sliceLabel={(d) => `${d.value}%`}
        slicesLabelsSkipAngle={10}
        slicesLabelsTextColor="#333333"
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        enableSlicesLabels={false}
        tooltipFormat={(value) => `${value}%`}
      />
    </div>
  );
};

export default DonutChart;
